import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Gallery from "@/pages/Gallery";
import MusicGallery from "@/pages/MusicGallery";
import AlbumDetail from "@/pages/AlbumDetail";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Success from "@/pages/Success";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Orders from "@/pages/Orders";
import ForgotPassword from "@/pages/ForgotPassword";
import Admin from "@/pages/Admin";
import { CartProvider } from "@/lib/cart";
import { AuthProvider } from "@/lib/auth";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/music" element={<MusicGallery />} />
                <Route path="/album/:id" element={<AlbumDetail />} />
                <Route path="/photography" element={<Gallery type="photography" />} />
                <Route path="/drawings" element={<Gallery type="drawing" />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/success" element={<Success />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
          </BrowserRouter>
          <Toaster
            position="top-center"
            theme="dark"
            toastOptions={{
              style: { background: "#09120C", color: "#fff", border: "1px solid #1A2B20" },
            }}
          />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
